const steps = [
  {
    step: "01",
    icon: "ri-search-line",
    title: "Find Your Category",
    description: "Browse our organized dropdown menu or category cards to locate the product type you are looking for — from Shoes to Perfumes, everything is sorted for instant access.",
  },
  {
    step: "02",
    icon: "ri-scales-3-line",
    title: "Compare Products",
    description: "Review product details, QC photos, and community feedback within the Vigorbuy spreadsheet to compare options side by side and identify the best value picks.",
  },
  {
    step: "03",
    icon: "ri-external-link-line",
    title: "Visit Main Website",
    description: "Click through to the main Vigorbuy spreadsheet website to complete your shopping. All links are verified and lead directly to the official product pages.",
  },
];

export default function HowItWorks() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            How <span className="text-primary-500">Vigorbuy Spreadsheet</span> Works
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            Using the Vigorbuy spreadsheet is simple. Follow these three easy steps to start discovering amazing products today.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((item, idx) => (
            <div key={item.step} className="relative group">
              <div className="text-center p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 h-full">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100/70 text-primary-600 mx-auto mb-5 group-hover:bg-primary-200/70 transition-colors">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-accent-500 text-background-50 text-xs font-bold mb-3">
                  {item.step}
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100/70 text-accent-500">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}